const Movement = Object.freeze({
  DOWN: "down",
  UP: "up",
})

export default Movement
